import { IComponentOptions } from 'angular';
import { CoursePaymentWizardViewController } from './course-payment-wizard-view.controller';
import template from './course-payment-wizard-view.component.html';

export const CoursePaymentWizardViewComponent = {
	bindings: {
		onError: '&',
		onSuccess: '&'
	},
	controller: CoursePaymentWizardViewController,
	require: {
		wizardController: '^wizard'
	},
	template
} as IComponentOptions;
